import { LOYALTY_POINT_HISTORY, LOYALTY_POINT_STATUS, LOYALTY_POINT_WITHDRAW } from './contants';

const initState = {
	loyaltyPoint: [],
	loyaltyPointHistory: [],
	loyaltyPointWithdraw: [],
	// Master = hạng cao nhất, suy ra từ rank của login-streak. Để ở store cho
	// mọi nơi (Home, DailyReward...) dùng chung thay vì tự tính lại.
	// isMaster: false,
}

const reducerLoyaltyPoint = (state = initState, actions) => {
	switch (actions.type) {
		case LOYALTY_POINT_STATUS:
			return {
				...state,
				loyaltyPoint: actions.payload.data,
				isMaster: actions.payload.data?.rank?.toUpperCase() === 'MASTER',
			}
		case LOYALTY_POINT_HISTORY:
			return {
				...state,
				loyaltyPointHistory: actions.payload.data,
			}
		case LOYALTY_POINT_WITHDRAW:
			return {
				...state,
				loyaltyPointWithdraw: actions.payload.data,
			}
		default:
			return state
	}
}
export default reducerLoyaltyPoint
